<template>
    <div class="submenu_holder">

        <ul class="submenu items">
            <li class="item">
			<router-link :to="{ name: 'usersList' }">
				<span class="item_text">Seznam uporabnikov</span>
			</router-link>
			</li>

			<li class="item" v-if="getUserType == 2">
			<router-link :to="{ name: 'informing' }">
				<span class="item_text">Obveščanje</span>
			</router-link>
			</li>
        </ul>

    </div>
</template>


<script>
	import { mapActions } from 'vuex';
	
	export default {
        name: 'UsersSubMenu',

		data: function() {
			return {
			}
		},
		computed: {
            // Get loged user type
			getUserType(){
				return this.$store.state.user.type;
            },
		},
		methods: { 		
            ...mapActions([
            ]),
        },
		created(){
            
		}
	}
</script>


<style lang="scss" scoped>
</style>
